import styled from 'styled-components'
import { Box, Typography } from 'src/components'

export const OverContainerSection = styled(Box)`
    display: flex;
    align-items: center;
    position: relative;
    flex-direction: column;
`

export const OverContainer = styled(Box)`
    display: flex;
    justify-content: center;
    overflow: hidden;
    flex-direction: column;
    align-items: start;
    width: 100%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: column;
        justify-content: center;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        flex-direction: column;
        justify-content: center;
        width: 1200px;
    }
`
export const ContentInformation = styled(Box)`
    display: flex;
    flex-direction: column;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`

export const NameTypography = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 31px;
    color: ${({ theme }) => theme.colors.white};
    -webkit-background-clip: text;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 41px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 51px;
    }
`
export const PositionTypography = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 31px;
    text-transform: capitalize;
    color: ${({ theme }) => theme.colors.white};
    -webkit-background-clip: text;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 41px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 41px;
    }
`
export const InformationPerson = styled(Box)`
    display: flex;
    justify-content: center;
    overflow: hidden;
    flex-direction: column;
    width: 95%;
    align-items: start;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: column;
        justify-content: center;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        flex-direction: row;
        justify-content: space-between;
        width: 1200px;
    }
`
export const VideoSection = styled.video`
    width: 100%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 48%;
    }
`

export const ContentImage = styled(Box)`
    width: 100%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 48%;
        background: #030c21;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`

export const ImageSection = styled.img`
    width: 100%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 310px;
    }
`
export const AboutSection = styled(Box)`
    width: 100%;
    display: flex;
    align-items: start;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 48%;
    }
`
export const AboutTitleTypography = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    line-height: 30px;
    width: 100%;
    display: flex;
    justify-content: start;
    text-transform: capitalize;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`

export const AboutContentTypography = styled(Typography)`
    font-family: inherit;
    font-style: normal;

    line-height: 19px;
    text-transform: capitalize;
    color: ${({ theme }) => theme.colors.white};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 29px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 25px;
    }
`
export const SocialCard = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 80%;

    justify-content: space-between;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
